import gql from 'graphql-tag'

export const ACCOUNT_DELETE_MUTATION = gql`
    mutation accountDelete(
        $id: ID!
    ) {
        accountDelete(
            id: $id
        ) {
            status
        }
    }
`
